import TransferUpahProduksiApi from "./TransferUpahProduksiApi"

export default TransferUpahProduksiApi